/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import {
  type AnimatedIllustrativeBaseIconProps,
  AnimatedIllustrativeIcon,
} from "../animated-illustrative-icon";
import animationData from "../assets/json/hand-heart-duocolor-animated.json";

export const IllustrativeIconHandHeartDuocolorAnimated = (props: AnimatedIllustrativeBaseIconProps) => (
  <AnimatedIllustrativeIcon {...props} json={animationData} />
);

IllustrativeIconHandHeartDuocolorAnimated.displayName = "IllustrativeIconHandHeartDuocolorAnimated";
